import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import UTCheck from '../UTCheck';

import icInProgress from './assets/ic_progress.png';
import styles from './styles';

const variants = ['icon', 'lightBlue', 'gray', 'green', 'lightGray'];

function UTTag({ children, checked, inProgress, ...props }) {
  const style = variants.filter(variant => props[variant]).map(variant => styles[variant]);

  const content = <span style={[styles.textbase, props.textStyle]}>{children}</span>;

  return (
    <div style={[styles.base, style, props.style]}>
      {!inProgress ? (
        <div style={styles.checkedBackground}>
          <UTCheck style={styles.checkedOk} />
        </div>
      ) : (
        <img alt="" src={icInProgress} style={styles.iconStyle} />
      )}
      <div style={styles.content}>{content}</div>
    </div>
  );
}

UTTag.propTypes = {
  textStyle: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  checked: PropTypes.bool,
  inProgress: PropTypes.bool
};

export default Radium(UTTag);
